// extracted by mini-css-extract-plugin
export default {"card":"nVn2apcf","name":"IxwpYZAd","jobTitle":"saMjV3M_","imageContainer":"tQ5DSG3Z","quoteSign":"b5w89Hnq","quoteTextContainer":"FfYtV2Ih","mobile":"mobile","quoteText":"LeYZDUNW"};